  /* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useState } from "react";
import Product1 from "../../assets/images/product-1.webp";
import Product2 from "../../assets/images/product-2.webp";
import Product3 from "../../assets/images/product-3.webp";
import Product4 from "../../assets/images/product-4.webp";
import HIW1 from "../../assets/images/icon-destination.webp";
import HIW2 from "../../assets/images/icon-payment.webp";
import HIW3 from "../../assets/images/icon-trip-planning.webp";
import HIW4 from "../../assets/images/icon-booking.webp";
import TopRated1 from "../../assets/images/umrah-package.webp";
import TopRated2 from "../../assets/images/umrah-land-package.webp";
import TopRated3 from "../../assets/images/umrah-e-payment.webp";
import TopRated4 from "../../assets/images/umrah-hajj-package.webp";
import TopRatedIcon1 from "../../assets/images/icon-air-fair.webp";
import TopRatedIcon2 from "../../assets/images/icon-e-visa.webp";
import TopRatedIcon3 from "../../assets/images/icon-accommodation.webp";
import TopRatedIcon4 from "../../assets/images/icon-transportation.webp";
import TopRatedIcon5 from "../../assets/images/icon-vaildity.webp";
import TopRatedIcon6 from "../../assets/images/icon-multiple-entries.webp";
import TopRatedIcon7 from "../../assets/images/icon-90.webp";
import DealWeekImg from "../../assets/images/qatar-airways.webp";
import DealWeekImg2 from "../../assets/images/etihad-airways.webp";
import DealWeekImg3 from "../../assets/images/emirates-airlines.webp";
import CounterImg1 from "../../assets/images/icon-experience.webp";
import CounterImg2 from "../../assets/images/icon-peoples.webp";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Col from "react-bootstrap/Col";
import FlightSearch from "components/Home/FlightSearch";
import { Link, useLocation } from "react-router-dom";
import { Fade, Zoom } from "react-reveal";
import { Helmet } from "react-helmet-async";
  import { FaWpforms } from "react-icons/fa6";
  import { MdFlight } from "react-icons/md";
  import { RiHotelFill } from "react-icons/ri";
  import { BsPassportFill } from "react-icons/bs";
  import Modal from 'react-bootstrap/Modal';

import CountUp from "react-countup";
import {
  EVISA_INQ_TYPE,
  FLIGHT_HOTEL_INQ_TYPE,
  FLIGHT_INQ_TYPE,
  HAJJ_INQ_TYPE,
  UMRAH_INQ_TYPE,
} from "constants/common";
import CallingModal from "components/common/CallingModal";
import { random } from "lodash";
import CustomerSays from "./CustomerSays";
import HajjUmrahInqForm from "components/Home/HajjUmrahInqForm";
import "./home.scss";
import { useDispatch } from "react-redux";
import DashBoardSlider from "components/common/DashBoardSlider";
// import FacebookMsg from "components/common/FacebookMsg";
import LogoSlider from "components/Home/LogoSlider";
import image from "../Umrah/Monthly/SeptemberUmrahPackage/september-umrah.jpeg"
  // import {Button} from "antd";
  // import WhyChooseUs from "../../components/WhyChooseUs/WhyChooseUs";
  // import LandUmrahPackages from "../../components/LandUmrahPackages/LandUmrahPackages";
  // import ContactFormUsFormGlobal from "../../components/common/ContactFormUsFormGlobal";
const Home = () => {
  const [show, setShow] = useState(false);
  const [selectedKey, setTab] = useState("umrah_inq");
  const [windowWidth, setWindowWidth] = useState(0);
  const [modalShow, setModalShow] = useState(true);
  const { search } = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    if (search === `?tab=eVisa`) {
      setTab("eVisa");
    }
  }, [search]);
  const handleClose = () => setShow(false);
  const handleShow = (price) => {
    setShow(true);
    setModalPrice(price);
  };
  const [price1, setPrice1] = useState(false);
  const [price2, setPrice2] = useState(false);
  const [price3, setPrice3] = useState(false);
  const [modalPrice, setModalPrice] = useState(false);

  useEffect(() => {
    setPrice1(random(650, 1099));
    setPrice2(random(650, 1099));
    setPrice3(random(650, 1099));
    dispatch({
      type: "ON_SET_TRIP_DETAILS",
      payload: null,
    });
  }, []);

  let resizeWindow = () => {
    setWindowWidth(window.screen.width);
  };

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  return (
      <>
        <Helmet prioritizeSeoTags>
          <title>
            Best Hajj & Umrah packages in Chicago 2025
            {/* Chicago Hajj & Umrah | Air Ticket Booking, Hajj & Umrah eVisa and
          Packages at Affordable Prices from USA | Chicago Hajj & Umrah */}
          </title>
          <meta
              name="keywords"
              data-react-helmet="true"
              content={`flight, flights, flight booking, hajj, hajj 2025, umrah, hajj and umrah, hajj  ${new Date().getFullYear()},  Umrah  ${new Date().getFullYear()}, hajj evisa, umrah evisa, evisa, hajj visa, umrah visa`}
              // content={`flight, flights, flight booking, umrah, hajj and umrah,  Umrah  ${new Date().getFullYear()} , umrah evisa, evisa, umrah visa`}
          ></meta>
          <meta
              name="description"
              data-react-helmet="true"
              content={`Looking for the best Hajj & Umrah packages in Chicago? Book your flight and hotel at affordable prices by Chicago Hajj and Umrah.`}
          ></meta>
          {/* Hajj and Umrah ${new Date().getFullYear()} packages from USA, eVisa for Hajj and Umrah, Flight and Hotel Booking at affordable prices by Chicago Hajj and Umrah */}


          <link rel="canonical" href="https://www.chicagohajj.com/"/>

          <meta
              data-react-helmet="true"
              property="og:title"
              content="Chicago Hajj & Umrah"
          />
          <meta data-react-helmet="true" property="og:type" content="booking"/>
          <meta
              data-react-helmet="true"
              property="og:url"
              content="https://www.chicagohajj.com/"
          />
          <meta
              data-react-helmet="true"
              name="twitter:title"
              content="Chicago Hajj & Umrah"
          />
          <meta
              data-react-helmet="true"
              name="twitter:description"
              content=" Offering tour packages for individuals or groups."
          />
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/banner/Economy-desk.webp" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/banner/Standard-desk.webp" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/banner/Luxury-desk.webp" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/banner/hajj-packages-Slider-Desktop.jpg" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/banner/Premium-desk.webp" as="image"/>

          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/mobile_banner/hajj-packages-Slider-Mobile.jpg" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/mobile_banner/Luxury-Mob.webp" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/mobile_banner/Standard-mob.webp" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/mobile_banner/Economy-Mob.webp" as="image"/>
          <link rel="preload" href="https://chicago-hajj-umrah.s3.amazonaws.com/mobile_banner/Premium-Mob.webp" as="image"/>

          <link rel="preload" href={image} as="image"/>
        </Helmet>
        {/*    <Modal*/}
        {/*      show={modalShow}*/}
        {/*      onHide={() => setModalShow(false)}*/}
        {/*    size="md"*/}
        {/*    aria-labelledby="contained-modal-title-vcenter"*/}
        {/*    centered*/}
        {/*  >*/}
        {/*    <div className="modal-close-button" onClick={() => setModalShow(false)}>*/}

        {/*</div>*/}
        {/*<Modal.Body className="newModalBody">*/}
        {/*</Modal.Body>*/}

        <Modal
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={() => setModalShow(false)}
            show={modalShow}
        >
          <Modal.Header closeButton>

          </Modal.Header>
          <Modal.Body className="newModalBody">
            <Link to="/umrah/september-umrah-package">
            <img  style={{ width:"100%"}} src={image} alt="September 2025 Umrah Package" width="auto" height="auto" />
            </Link>
          </Modal.Body>

        </Modal>


        <DashBoardSlider/>

        {/*<ContactFormUsFormGlobal/>*/}



        <section className='logosection'>
          {/*<h2 className="logosliderheading">Airline Discount Voucher</h2>*/}
          <LogoSlider/>
        </section>

        {/*<section className="bg-gray bg-graydiv">*/}
        <section className="">
          {/* Searchbox section */}
          <div className="search-section bg-white">
            <Tab.Container
                onSelect={(key) => {
                  console.log("selected: " + key);
                  setTab(key);
                }}
                id="left-tabs-example"
                defaultActiveKey="hajj_inq"
                activeKey={selectedKey}
            >
              <Row>
                <Col sm={12}>
                  <Nav variant="pills" className="flex-row custom-tabs">
                    {/* <Nav.Item>
                    <Nav.Link eventKey="hajj_inq">Hajj Inquiry</Nav.Link>
                  </Nav.Item> */}
                    <Nav.Item>
                      <Nav.Link eventKey="umrah_inq">
                        <div className="tabsdivlogo">
                          <FaWpforms size={21}/>
                          <span>Inquiry</span>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="flight">
                        <div className="tabsdivlogo">
                          <MdFlight size={23}/>
                          <span>Flight</span>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="flights_hotels">
                        <div className="tabsdivlogo">
                          <RiHotelFill size={23}/>
                          <span>Hotel</span>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>

                      <Nav.Link eventKey="eVisa">

                        <div className="tabsdivlogo">
                          <BsPassportFill size={23}/>
                          <span>eVisa</span>
                        </div>
                      </Nav.Link>

                    </Nav.Item>
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content className="custom-content">
                    {/* <Tab.Pane eventKey="hajj_inq">
                    <HajjUmrahInqForm mainType={HAJJ_INQ_TYPE} />
                  </Tab.Pane> */}
                    <Tab.Pane eventKey="umrah_inq">
                      <HajjUmrahInqForm mainType={UMRAH_INQ_TYPE}/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="flight">
                      <FlightSearch mainType={FLIGHT_INQ_TYPE}/>
                    </Tab.Pane>
                    <Tab.Pane
                        eventKey="flights_hotels"
                        className="second-left-section"
                    >
                      <FlightSearch mainType={FLIGHT_HOTEL_INQ_TYPE}/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="eVisa">
                      <FlightSearch mainType={EVISA_INQ_TYPE}/>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
          {/* Top Rated section */}
          <div className="top-rated-section section-spacing">
            <div className="section-content text-center  container">
              <h1 className="section-title font-weight-semibold mb-3">
                Your Journey, Our Expertise:
                <span className="d-block">Leading the Way in Hajj & Umrah </span>
              </h1>
            </div>
            <div className="container top-rated-list">
              <div id="setforresponsive" className="row">
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <Link className="text-black" to="/packages/Umrah">
                    <div className="top-rated-item four-top-rated-item">
                      <div className="top-rated-img position-relative">
                        <img
                            src={TopRated1}
                            alt="Top Rated 1"
                            className="img-fluid"
                        />
                        <div className="top-rated-content">
                          <div className="top-rated-content-text-title  text-center">
                            <h4 className="text-uppercase font-weight-semibold">
                              UMRAH PACKAGES
                            </h4>
                            <p className="font-weight-500 mb-30">
                              Looking for the best Umrah Packages from USA?
                            </p>
                          </div>
                          <hr className="top-rated-hr"/>
                          <ul className="list-style-none top-rated-ul four-services">
                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon1}
                                    alt="Top Rated 1"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                  Air Fare
                                </p>
                              </div>
                            </li>
                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon3}
                                    alt="Top Rated 3"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                  Hotel
                                </p>
                              </div>
                            </li>
                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon2}
                                    alt="Top Rated 2"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                  Umrah E-Visa
                                </p>
                              </div>
                            </li>

                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon4}
                                    alt="Top Rated 4"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                  Transportation
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <Link className="text-black" to="/packages/umrah-land">
                    <div role="button" className="top-rated-item">
                      <div className="top-rated-img position-relative">
                        <img
                            src={TopRated2}
                            alt="Top Rated 2"
                            className="img-fluid"
                        />
                        <div className="top-rated-content">
                          <div className="top-rated-content-text-title  text-center">
                            <h4 className="text-uppercase font-weight-semibold">
                              UMRAH LAND PACKAGES
                            </h4>
                            <p className="font-weight-500 mb-30">
                              Looking for the best Umrah Packages from USA?
                            </p>
                          </div>
                          <hr className="top-rated-hr"/>
                          <ul className="list-style-none top-rated-ul three-services">
                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon2}
                                    alt="Top Rated 2"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 mt-1 font-weight-semibold">
                                  Umrah E-Visa
                                </p>
                              </div>
                            </li>
                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon3}
                                    alt="Top Rated 3"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 font-weight-semibold mt-1">
                                  Hotel
                                </p>
                              </div>
                            </li>
                            <li className="top-rated-li-content">
                              <div className="top-rated-icon-section">
                                <img
                                    src={TopRatedIcon4}
                                    alt="Top Rated 4"
                                    className="img-fluid"
                                />
                                <p className="font-size-12 mb-0 font-weight-semibold mt-1">
                                  Transportation
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  {/* <Link
                  onClick={() => {
                    let element = document.getElementById(
                      "flight-search-container"
                    );
                    if (element) {
                      element.scrollIntoView({ behavior: "smooth" });
                      setTab("eVisa");
                    }
                  }}
                  className="text-black"
                  to="/?type=evisa"
                > */}
                  <div className="top-rated-item">
                    <div className="top-rated-img position-relative">
                      <img
                          src={TopRated3}
                          alt="Top Rated 3"
                          className="img-fluid"
                      />
                      <div className="top-rated-content">
                        <div className="top-rated-content-text-title  text-center">
                          <h4 className="text-uppercase font-weight-semibold">
                            TOURIST E-VISA
                          </h4>
                          <p className="font-weight-500 mb-30">
                            Looking for a E-Visa from USA ?
                          </p>
                        </div>
                        <hr className="top-rated-hr"/>
                        <ul className="list-style-none top-rated-ul three-services">
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon5}
                                  alt="Top Rated 5"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0  font-weight-semibold">
                                1 Year Validity
                              </p>
                            </div>
                          </li>
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon6}
                                  alt="Top Rated 6"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0 font-weight-semibold ">
                                Single/Multiple Entries
                              </p>
                            </div>
                          </li>
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon7}
                                  alt="Top Rated 7"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0 font-weight-semibold ">
                                Stay upto 90 Days
                                {/* <span className="d-block"> </span> */}
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* </Link> */}
                </div>
                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  {/* <Link className="text-black" to={`/packages/Hajj`}> */}
                  <div className="top-rated-item last-top-reated-item  four-top-rated-item">
                    <div className="top-rated-img position-relative">
                      <img
                          src={TopRated4}
                          alt="Top Rated 4"
                          className="img-fluid"
                      />
                      <div className="top-rated-content">
                        <div className="top-rated-content-text-title  text-center">
                          <h4 className="text-uppercase font-weight-semibold">
                            HAJJ PACKAGES
                          </h4>
                          <p className="font-weight-500 mb-30">
                            Looking for the best Hajj Packages from USA ?
                          </p>
                        </div>
                        <hr className="top-rated-hr"/>
                        <ul className="list-style-none top-rated-ul four-services">
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon1}
                                  alt="Top Rated 1"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                Air Fare
                              </p>
                            </div>
                          </li>
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon3}
                                  alt="Top Rated 3"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                Hotel
                              </p>
                            </div>
                          </li>
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon2}
                                  alt="Top Rated 2"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                Hajj E-Visa
                              </p>
                            </div>
                          </li>
                          <li className="top-rated-li-content">
                            <div className="top-rated-icon-section">
                              <img
                                  src={TopRatedIcon4}
                                  alt="Top Rated 4"
                                  className="img-fluid"
                              />
                              <p className="font-size-12 mb-0 font-weight-semibold ml-2">
                                Transportation
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* </Link> */}
                </div>
              </div>
            </div>
          </div>
          {/* Deal of the week section */}
          {/* Deal of the week section */}
          <div className="deal-week-section">
            <div className="row deal-week-list mx-0">
              <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                <div
                    className="deal-week-item cursor-pointer"
                    onClick={() => handleShow(price3)}
                >
                  <h5 className="font-weight-semibold">Deal of the Week</h5>
                  <div className="deal-week-text-img">
                    <img
                        src={DealWeekImg}
                        alt="Week Deal"
                        className="img-fluid"
                    />
                    <div className="deal-week-right">
                      <h2 className="font-weight-bold">
                        <small>$</small>
                        {price3} <small>*</small>
                      </h2>
                      <div className="read-more-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="6"
                            height="10"
                            viewBox="0 0 6 10"
                            fill="none"
                        >
                          <path
                              d="M1.06417 0.348301C0.865612 0.130112 0.564113 0.1556 0.390554 0.40499C0.217169 0.654599 0.237444 1.03363 0.435822 1.25182L3.84338 4.99991L0.435648 8.74823C0.237095 8.96642 0.216995 9.34544 0.390379 9.59483C0.563938 9.84444 0.865438 9.86993 1.06399 9.65174L4.88211 5.45167C4.98576 5.33785 5.04519 5.17306 5.04519 4.99991C5.04519 4.82677 4.98576 4.66219 4.88211 4.54815L1.06417 0.348301Z"
                              fill="#1C2745"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                <div
                    className="deal-week-item cursor-pointer"
                    onClick={() => handleShow(price1)}
                >
                  <h5 className="font-weight-semibold">Deal of the Week</h5>
                  <div className="deal-week-text-img">
                    <img
                        src={DealWeekImg2}
                        alt="Week Deal"
                        className="img-fluid"
                    />
                    <div className="deal-week-right">
                      <h2 className="font-weight-bold">
                        <small>$</small>
                        {price1} <small>*</small>
                      </h2>
                      <div className="read-more-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="6"
                            height="10"
                            viewBox="0 0 6 10"
                            fill="none"
                        >
                          <path
                              d="M1.06417 0.348301C0.865612 0.130112 0.564113 0.1556 0.390554 0.40499C0.217169 0.654599 0.237444 1.03363 0.435822 1.25182L3.84338 4.99991L0.435648 8.74823C0.237095 8.96642 0.216995 9.34544 0.390379 9.59483C0.563938 9.84444 0.865438 9.86993 1.06399 9.65174L4.88211 5.45167C4.98576 5.33785 5.04519 5.17306 5.04519 4.99991C5.04519 4.82677 4.98576 4.66219 4.88211 4.54815L1.06417 0.348301Z"
                              fill="#1C2745"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                <div
                    className="deal-week-item cursor-pointer"
                    onClick={() => handleShow(price2)}
                >
                  <h5 className="font-weight-semibold">Deal of the Week</h5>
                  <div className="deal-week-text-img">
                    <img
                        src={DealWeekImg3}
                        alt="Week Deal"
                        className="img-fluid"
                    />
                    <div className="deal-week-right">
                      <h2 className="font-weight-bold">
                        <small>$</small>
                        {price2} <small>*</small>
                      </h2>
                      <div className="read-more-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="6"
                            height="10"
                            viewBox="0 0 6 10"
                            fill="none"
                        >
                          <path
                              d="M1.06417 0.348301C0.865612 0.130112 0.564113 0.1556 0.390554 0.40499C0.217169 0.654599 0.237444 1.03363 0.435822 1.25182L3.84338 4.99991L0.435648 8.74823C0.237095 8.96642 0.216995 9.34544 0.390379 9.59483C0.563938 9.84444 0.865438 9.86993 1.06399 9.65174L4.88211 5.45167C4.98576 5.33785 5.04519 5.17306 5.04519 4.99991C5.04519 4.82677 4.98576 4.66219 4.88211 4.54815L1.06417 0.348301Z"
                              fill="#1C2745"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>


        {/*<section>*/}
        {/*  <WhyChooseUs/>*/}
        {/*</section>*/}

        {/* <section>
        <LandUmrahPackages/>
      </section> */}


        <section className="makeyourownpackage">
          <h2>Get Umrah packages for your own city</h2>
          <p>Select your city below and we’ll show you Umrah packages that exactly meet your requirements</p>
          <div className="makeyourownpackage-wrapper">


            <Link className="makeyourownpackage-wrapper-card" to={`/umrah/4-Days-Umrah-Packages-from-USA-in-2024`}>
              <h5>4</h5>
              <h6>Days</h6>
            </Link>


            <Link className="makeyourownpackage-wrapper-card" to={`/umrah/6-Days-Umrah-Packages-from-USA-in-2024`}>
              <h5>6</h5>
              <h6>Days</h6>
            </Link>

            <Link className="makeyourownpackage-wrapper-card" to={`/umrah/8-Days-Umrah-Packages-from-USA-in-2024`}>
              <h5>8</h5>
              <h6>Days</h6>
            </Link>
            <Link className="makeyourownpackage-wrapper-card" to={`/umrah/10-Days-Umrah-Packages-from-USA-in-2024`}>
              <h5>10</h5>
              <h6>Days</h6>
            </Link>
            <Link className="makeyourownpackage-wrapper-card" to={`/umrah/make-your-custom-package`}>
              <h4>make my custom package</h4>
            </Link>
          </div>
        </section>

        {/* How it works */}
        <Fade>
          <section className="how-it-works section-spacing">
            <div className="section-content text-center  container">
              <h2 className="section-title font-weight-semibold mb-3">
                Blueprint Your Experience
              </h2>

              <h6 className="w-xl-75 m-auto">Steps for Your Journey</h6>
            </div>
            <div className="row how-it-work-list-custom">
              <div className="col-lg-6 col-md-6 col-sm-12 mb-md-4 mb-4">
                <div className="how-it-work-item-custom">
                  <div className="how-it-work-img-custom">
                    <img src={HIW1} alt="step 1" className="img-fluid"/>
                    <div className="steps">
                      <span>1</span>
                    </div>
                  </div>
                  <h6 className="how-it-work-title font-weight-semibold">
                    Dream
                  </h6>
                  <p className="color-secondary">
                    Imagine your perfect pilgrimage, visualizing the holy cities,
                    sacred rituals, and transformative experiences you desire.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 mb-md-4 mb-4">
                <div className="how-it-work-item-custom">
                  <div className="how-it-work-img-custom">
                    <img src={HIW4} alt="step 2" className="img-fluid"/>
                    <div className="steps">
                      <span>2</span>
                    </div>
                  </div>
                  <h6 className="how-it-work-title font-weight-semibold">
                    Booking
                  </h6>
                  <p className="color-secondary">
                    Select your desired package and make a reservation to secure
                    your spot for the journey of a lifetime.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 mb-md-4 mb-4">
                <div className="how-it-work-item-custom">
                  <div className="how-it-work-img-custom">
                    <img src={HIW3} alt="step 3" className="img-fluid"/>
                    <div className="steps">
                      <span>3</span>
                    </div>
                  </div>
                  <h6 className="how-it-work-title font-weight-semibold">
                    Trip Planning
                  </h6>
                  <p className="color-secondary">
                    Work closely with our experienced travel experts who will
                    assist you in customizing your itinerary, including
                    accommodations, activity, visa, and ground transportation
                    arrangements.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 mb-md-4 mb-4">
                <div className="how-it-work-item-custom">
                  <div className="how-it-work-img-custom">
                    <img src={HIW2} alt="step 4" className="img-fluid"/>
                    <div className="steps">
                      <span>4</span>
                    </div>
                  </div>
                  <h6 className="how-it-work-title font-weight-semibold">
                    Payment for Package
                  </h6>
                  <p className="color-secondary">
                    Finalize your booking by making a secure payment for your
                    chosen package, ensuring a seamless experience from start to
                    finish.
                  </p>
                </div>
              </div>
            </div>
          </section>
          {/* Testimonials */}
          <Fade>
            <section className="how-it-works section-spacing">
              <div className="section-content text-center  container">
                <h2 className="section-title font-weight-semibold mb-3">
                  Customer Feedback
                </h2>
                <h6 className="w-xl-75 m-auto">What They're Saying About Us</h6>
                {/* <h2 className="section-title font-weight-semibold mb-3">
                What They're Saying About Us
              </h2> */}
              </div>
              {/*<NewCustomerSays />*/}
              <CustomerSays/>
            </section>
          </Fade>

          {/* Counter section  */}
          <section className="counter-section mb-70">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-sm-12 col-md-12 col-12">
                  <div className="counter-list">
                    <div className="counter-item">
                      <div className="counter-img">
                        <img
                            src={CounterImg1}
                            alt="Counter Image"
                            className="img-fluid"
                        />
                      </div>
                      <div className="counter-content">
                        <h2 className="font-weight-bold text-white count">
                          <CountUp delay={3} end={20} duration={5}/>+
                        </h2>
                        <h4 className="text-white mb-0">Years of experience</h4>
                      </div>
                    </div>
                    <div className="counter-item">
                      <div className="counter-img">
                        <img
                            src={CounterImg2}
                            alt="Counter Image 2"
                            className="img-fluid"
                        />
                      </div>
                      <div className="counter-content">
                        <h2 className="font-weight-bold text-white count">
                          <CountUp delay={3} end={100} duration={5}/>
                          K+
                        </h2>
                        <h4 className="text-white mb-0">Customers served</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Our Products */}
          <section className="our-products section-spacing our-product-hide">
            {/* section title */}
            <div className="section-content text-center  container">
              <h2 className="section-title font-weight-semibold mb-30">
                Online Selling Products
              </h2>
              {/* <h6 className="w-xl-75 m-auto">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
              eleifend est quis Vestibulum ante ipsum primis in faucibus orci
              luctus
            </h6> */}
            </div>
            {/* Our products */}
            <div className="row product-list">
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="product-item">
                  <div className="product-img">
                    <img
                        src={Product1}
                        alt="Product 1"
                        style={{
                          height: "350px",
                        }}
                        className="img-fluid"
                    />
                  </div>
                  <div className="product-content">
                    <h6 className="product-desc">
                      Solid Color Bubble Chiffon Scarf Muslim Hijab
                    </h6>
                    <h4 className="color-primary font-weight-bold text-uppercase">
                      Coming Soon
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="product-item">
                  <div className="product-img">
                    <img
                        src={Product2}
                        style={{
                          height: "350px",
                        }}
                        alt="Product 2"
                        className="img-fluid"
                    />
                  </div>
                  <div className="product-content">
                    <h6 className="product-desc">
                      Islamic Prayer Beads Olive Wood Muslim Tasbih...
                    </h6>
                    <h4 className="color-primary font-weight-bold text-uppercase">
                      Coming Soon
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="product-item">
                  <div className="product-img">
                    <img
                        src={Product3}
                        style={{
                          height: "350px",
                        }}
                        alt="Product 3"
                        className="img-fluid"
                    />
                  </div>
                  <div className="product-content">
                    <h6 className="product-desc">
                      Sweatproof Mobile Waist Bellt Pouch Bag.
                    </h6>
                    <h4 className="color-primary font-weight-bold text-uppercase">
                      Coming Soon
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="product-item">
                  <div className="product-img">
                    <img
                        src={Product4}
                        style={{
                          height: "350px",
                        }}
                        alt="Product 4"
                        className="img-fluid"
                    />
                  </div>
                  <div className="product-content">
                    <h6 className="product-desc">
                      DOMUM Haj and Umrah Ehram Altar Cloth
                    </h6>
                    <h4 className="color-primary font-weight-bold text-uppercase">
                      Coming Soon
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Fade>

        {/* Modal */}
        {/* Calling and Cheapest Rate Modal */}
        <CallingModal
            show={show}
            handleClose={handleClose}
            modalPrice={modalPrice}
        />
      </>
  );
};

  export default Home;
